import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { HttpApiService } from 'src/app/shared/services/http.api.service';
import { InputsResultSummaryPWC, ResultSummaryPWC } from './eea-output-project-pwc.interface.model';

@Injectable({
  providedIn: 'root'
})
export class EeaOutputProjectPwcApiService extends HttpApiService {
  override apiUrl: string = environment.BAMS_Api_URL;

  getSummaryResultPwc(projectPk: number): Observable<ResultSummaryPWC[]> {
   const endpoint = `api/output/getSummaryResultPwc/${projectPk}`;
    return this.get(endpoint).pipe(map((data: any) => data.Value));
  }

  getResultSummaryPwcInputs(projectPk: number): Observable<InputsResultSummaryPWC[]> {
    const endpoint = `api/getResultSummaryPwcInputs/${projectPk}`;
     return this.get(endpoint).pipe(map((data: any) => data.Value));
   }

}
